/**
 * @generated SignedSource<<e97fdafa20129a19a71623c0ed4eb59e>>
 * @relayHash 2efdea558d49f1b0dbee45f7e5adc6bc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 98ab0ac6008fecd020ee4a7884fe785e2c6e39df68093c3845273b0583a04faa

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HelpCenterMediaConfigOperationType = "BANNER_UPLOAD" | "LOGO_UPLOAD" | "READ" | "%future added value";
export type hubHomeContentWrapperQuery$variables = {
  cloudId: string;
  hubAri: string;
  hubEditMode: boolean;
  includeLayoutTranslations?: boolean | null;
  isDraft?: boolean | null;
  operationType?: HelpCenterMediaConfigOperationType | null;
  pageAri: string;
  rovoConfigFromKosh?: boolean | null;
};
export type hubHomeContentWrapperQuery$data = {
  readonly helpCenter: {
    readonly " $fragmentSpreads": FragmentRefs<"hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference" | "hubHomeContent_AtlassianHubHome_HubInfo">;
  } | null;
  readonly me: {
    readonly user: {
      readonly accountId: string;
    } | null;
  };
  readonly " $fragmentSpreads": FragmentRefs<"hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference">;
};
export type hubHomeContentWrapperQuery = {
  response: hubHomeContentWrapperQuery$data;
  variables: hubHomeContentWrapperQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hubAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hubEditMode"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeLayoutTranslations"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isDraft"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "operationType"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageAri"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "rovoConfigFromKosh"
},
v8 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v9 = {
  "kind": "Variable",
  "name": "isDraft",
  "variableName": "isDraft"
},
v10 = {
  "kind": "Variable",
  "name": "pageAri",
  "variableName": "pageAri"
},
v11 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v12 = {
  "kind": "Variable",
  "name": "operationType",
  "variableName": "operationType"
},
v13 = [
  {
    "kind": "ScalarField",
    "name": "asapIssuer"
  },
  {
    "kind": "ScalarField",
    "name": "mediaCollectionName"
  },
  {
    "kind": "ScalarField",
    "name": "mediaToken"
  },
  {
    "kind": "ScalarField",
    "name": "mediaUrl"
  }
],
v14 = {
  "kind": "Variable",
  "name": "helpCenterAri",
  "variableName": "hubAri"
},
v15 = {
  "kind": "ScalarField",
  "name": "locale"
},
v16 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v17 = {
  "kind": "ScalarField",
  "name": "type"
},
v18 = [
  {
    "kind": "ScalarField",
    "name": "default"
  }
],
v19 = {
  "kind": "ScalarField",
  "name": "cornerRadius"
},
v20 = {
  "concreteType": "HelpCenterNavigationBar",
  "kind": "LinkedField",
  "name": "navigationBar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "backgroundColor"
    },
    {
      "kind": "ScalarField",
      "name": "borderColor"
    },
    {
      "kind": "ScalarField",
      "name": "borderType"
    },
    (v19/*: any*/),
    {
      "kind": "ScalarField",
      "name": "padding"
    },
    {
      "kind": "ScalarField",
      "name": "positionType"
    },
    {
      "kind": "ScalarField",
      "name": "textColor"
    }
  ]
},
v21 = {
  "kind": "ScalarField",
  "name": "id"
},
v22 = {
  "concreteType": "HelpCenterPageName",
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": (v18/*: any*/)
},
v23 = [
  (v21/*: any*/),
  (v22/*: any*/),
  {
    "concreteType": "HelpCenterPageDescription",
    "kind": "LinkedField",
    "name": "description",
    "plural": false,
    "selections": (v18/*: any*/)
  },
  {
    "condition": "isDraft",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "isPublished"
      }
    ]
  }
],
v24 = [
  (v15/*: any*/),
  {
    "kind": "ScalarField",
    "name": "localeDisplayName"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "name": "hubHomeContentWrapperQuery",
    "selections": [
      {
        "args": (v8/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "hubAri",
                "variableName": "hubAri"
              },
              {
                "kind": "Variable",
                "name": "includeLayoutTranslations",
                "variableName": "includeLayoutTranslations"
              },
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "hubHomeContent_AtlassianHubHome_HubInfo"
          },
          {
            "args": [
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "hubBootstrap_AtlassianCompanyHubCommon_bootstrapQueryReference"
          }
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "hubBootstrap_AtlassianCompanyHubCommon_tenantContextsQueryReference"
      },
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v11/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v7/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "hubHomeContentWrapperQuery",
    "selections": [
      {
        "args": (v8/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "alias": "pageMediaConfig",
            "args": [
              {
                "kind": "Variable",
                "name": "ari",
                "variableName": "pageAri"
              },
              (v12/*: any*/)
            ],
            "concreteType": "HelpCenterMediaConfig",
            "kind": "LinkedField",
            "name": "hubMediaConfig",
            "plural": false,
            "selections": (v13/*: any*/)
          },
          {
            "condition": "includeLayoutTranslations",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  (v14/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "parentAri",
                    "variableName": "pageAri"
                  }
                ],
                "concreteType": "HelpCenterHubLayoutTranslations",
                "kind": "LinkedField",
                "name": "layoutTranslations",
                "plural": true,
                "selections": [
                  (v15/*: any*/),
                  {
                    "concreteType": "HelpCenterHubTranslationBlock",
                    "kind": "LinkedField",
                    "name": "blocks",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "localId"
                      },
                      {
                        "concreteType": "HelpCenterHubTranslationField",
                        "kind": "LinkedField",
                        "name": "fields",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "fieldPath"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "value"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "args": [
              (v14/*: any*/),
              (v9/*: any*/)
            ],
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v16/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasUnpublishedChanges"
                  },
                  (v17/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "hoistedProjectKey"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "slug"
                  },
                  {
                    "concreteType": "HelpCenterName",
                    "kind": "LinkedField",
                    "name": "name",
                    "plural": false,
                    "selections": (v18/*: any*/)
                  },
                  {
                    "concreteType": "HelpCenterBranding",
                    "kind": "LinkedField",
                    "name": "helpCenterBranding",
                    "plural": false,
                    "selections": [
                      (v20/*: any*/)
                    ]
                  },
                  {
                    "alias": "allPages",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "ids": []
                        }
                      }
                    ],
                    "concreteType": "HelpCenterPage",
                    "kind": "LinkedField",
                    "name": "pages",
                    "plural": true,
                    "selections": (v23/*: any*/),
                    "storageKey": "pages(filter:{\"ids\":[]})"
                  },
                  {
                    "alias": "customPages",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "ids": [],
                          "type": "CUSTOM"
                        }
                      }
                    ],
                    "concreteType": "HelpCenterPage",
                    "kind": "LinkedField",
                    "name": "pages",
                    "plural": true,
                    "selections": (v23/*: any*/),
                    "storageKey": "pages(filter:{\"ids\":[],\"type\":\"CUSTOM\"})"
                  },
                  {
                    "condition": "includeLayoutTranslations",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "siteDefaultLanguageTag"
                      },
                      {
                        "concreteType": "HelpCenterAnnouncements",
                        "kind": "LinkedField",
                        "name": "announcements",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "HelpCenterAnnouncement",
                            "kind": "LinkedField",
                            "name": "homePageAnnouncements",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "HelpCenterTranslation",
                                "kind": "LinkedField",
                                "name": "nameTranslationsRaw",
                                "plural": true,
                                "selections": (v24/*: any*/)
                              },
                              {
                                "concreteType": "HelpCenterTranslation",
                                "kind": "LinkedField",
                                "name": "descriptionTranslationsRaw",
                                "plural": true,
                                "selections": (v24/*: any*/)
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v17/*: any*/),
                  {
                    "alias": "currentPage",
                    "args": [
                      {
                        "fields": [
                          {
                            "items": [
                              {
                                "kind": "Variable",
                                "name": "ids.0",
                                "variableName": "pageAri"
                              }
                            ],
                            "kind": "ListValue",
                            "name": "ids"
                          },
                          {
                            "kind": "Variable",
                            "name": "isEditMode",
                            "variableName": "hubEditMode"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "filter"
                      }
                    ],
                    "concreteType": "HelpCenterPage",
                    "kind": "LinkedField",
                    "name": "pages",
                    "plural": true,
                    "selections": [
                      (v21/*: any*/),
                      (v22/*: any*/),
                      {
                        "condition": "rovoConfigFromKosh",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "concreteType": "HelpCenterPageRovoConfig",
                            "kind": "LinkedField",
                            "name": "rovoConfig",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "isCustomAgentsAvailable"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "isRovoEnabled"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "agentId"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "HelpCenterPageLayout",
                        "kind": "LinkedField",
                        "name": "pageLayout",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "HelpCenterLayoutAdf",
                            "kind": "LinkedField",
                            "name": "layoutAdf",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "HelpCenterLayoutAdfContentConnection",
                                "kind": "LinkedField",
                                "name": "content",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "HelpCenterLayoutAdfContentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "HelpCenterLayoutAdfContent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "content"
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "HelpCenterBranding",
                    "kind": "LinkedField",
                    "name": "helpCenterBranding",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "HelpCenterLogo",
                        "kind": "LinkedField",
                        "name": "logo",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "fileId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "url"
                          }
                        ]
                      },
                      {
                        "concreteType": "HelpCenterBrandingColors",
                        "kind": "LinkedField",
                        "name": "colors",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "primary"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "secondaryColor"
                          }
                        ]
                      },
                      (v20/*: any*/),
                      {
                        "concreteType": "HelpCenterBrandingTypography",
                        "kind": "LinkedField",
                        "name": "typography",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "headingFont"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "bodyFont"
                          }
                        ]
                      },
                      (v19/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "spaceDensity"
                      }
                    ]
                  }
                ],
                "type": "HelpCenter"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "message"
                  }
                ],
                "type": "QueryError"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v21/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "ari",
                "variableName": "hubAri"
              },
              (v12/*: any*/)
            ],
            "concreteType": "HelpCenterMediaConfig",
            "kind": "LinkedField",
            "name": "hubMediaConfig",
            "plural": false,
            "selections": (v13/*: any*/)
          }
        ]
      },
      {
        "condition": "hubEditMode",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "items": [
                  {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                  }
                ],
                "kind": "ListValue",
                "name": "cloudIds"
              }
            ],
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "cloudUrl"
              }
            ]
          }
        ]
      },
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v16/*: any*/),
              (v11/*: any*/),
              (v21/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "98ab0ac6008fecd020ee4a7884fe785e2c6e39df68093c3845273b0583a04faa",
    "metadata": {},
    "name": "hubHomeContentWrapperQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e9eb4d78b33244300deba8ae9efc4229";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
